import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, PageHeaderProps, Select, Spacing, Text } from 'zens-storybook'
import { ReactElement, Suspense } from 'react'
import { useNumberParams } from 'zens-router'

import { MenuAuth, MenuCompany } from '../menu'

import LayoutPageHeader from './pageheader'

const styles = StyleSheet.create({
  container: {
    paddingTop: Spacing.S,
  },
  top: {
    marginHorizontal: Spacing.S,
    flexDirection: 'row',
  },
  company: {
    marginRight: Spacing.XS,
  },
  companySkeleton: {
    minWidth: 200,
    backgroundColor: Color.graphicGrey,
    borderColor: Color.graphicGrey,
  },
  companySkeletonContent: {
    backgroundColor: Color.calmGrey,
  },
  skeletonContainer: {
    marginLeft: Spacing.S,
  },
  skeletonTop: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  skeletonMenu: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  skeletonBreadcrumb: {
    minWidth: 200,
  },
  skeletonContent: {
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: Spacing.L,
    marginTop: Spacing.M,
    justifyContent: 'space-between',
  },
  skeletonTitle: {
    minWidth: 200,
    marginLeft: -Spacing.M,
  },
})

interface Props extends PageHeaderProps {}

const LayoutHeader = (props: Props) => {
  const { style, ...otherProps } = props
  const [{ companyId }] = useNumberParams()

  return (
    <LayoutPageHeader
      style={[styles.container, style]}
      menu={
        <View style={styles.top}>
          <Suspense
            fallback={
              <Select.Skeleton
                round
                style={[styles.company, styles.companySkeleton]}
                contentStyle={styles.companySkeletonContent}
              />
            }
          >
            <MenuCompany style={styles.company} companyId={companyId} />
          </Suspense>
          <Suspense fallback={<MenuAuth.Skeleton />}>
            <MenuAuth companyId={companyId} />
          </Suspense>
        </View>
      }
      {...otherProps}
    />
  )
}

interface SkeletonProps extends ViewProps {
  breadcrumb?: true
  title?: true
  accessory?: ReactElement
}
LayoutHeader.Skeleton = (props: SkeletonProps) => {
  const { breadcrumb, title, accessory, style, ...otherProps } = props
  return (
    <View style={[styles.container, styles.skeletonContainer, style]} {...otherProps}>
      <View style={[styles.top, styles.skeletonTop]}>
        {breadcrumb && <Text.Skeleton style={styles.skeletonBreadcrumb} />}
        <View style={styles.skeletonMenu}>
          <Select.Skeleton
            round
            style={[styles.company, styles.companySkeleton]}
            contentStyle={styles.companySkeletonContent}
          />
          <MenuAuth.Skeleton />
        </View>
      </View>
      <View style={styles.skeletonContent}>
        {title && <Text.Skeleton level={1} style={styles.skeletonTitle} />}
        {accessory}
      </View>
    </View>
  )
}

export default LayoutHeader
